import React from 'react';
import Framework from "@beardeddevops/react.framework";
import APPCONFIG from "constants/Config";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const {UniversalModal} = Framework.Elements;

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Kiosks',
		url: '/kiosks',
		icon: 'desktop',
	}
];

export default class Kiosks extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button className="primary-button" onClick={this.toggle('modalKiosk')} size={"sm"}>
						<i className="fa fa-desktop"/>&nbsp;&nbsp;Add Kiosk
					</Button>
				</Framework.Components.PageBar>
				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Kiosks
						history={this.props.history}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</Framework.Errors.General>
				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					name={"Kiosk"}
					object={Objects.Kiosk}
					history={this.props.history}
					toggle={this.state['modalKiosk']}
					reportClose={this.reportClose('modalKiosk')}
					afterSave={this.handleAfterSave}
					size={'lg'}
					project={'pos'}
				/>
			</div>
		);
	}
}
